<div>

    <div class="container-fluid">
        <div class="row">
            <div class="col-8">
                <h3>{{league?.name}} - Iterations</h3>
            </div>
            <div class="col-4 d-flex justify-content-end align-items-center">
                <button mat-raised-button color="primary" (click)="onCreate()" [disabled]="isLoading">
                    Add Iteration <mat-icon>add</mat-icon>
                </button>
                <button mat-icon-button (click)="onCloseIterationsPanel.emit()" matTooltip="Close">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
        
        <gt-table [loading]="isLoading" [defaultPageSize]="10" [updateFilterEvent]="updateFilterEvent"
            [filter]="filter" [data]="iterations" (filterChanged)="getIterations()" [placeholder]="'Search by year'">
        </gt-table>
        <table mat-table [dataSource]="iterations" *ngIf="!isLoading">
            <ng-container matColumnDef="year">
                <th mat-header-cell *matHeaderCellDef> Year </th>
                <td mat-cell *matCellDef="let iteration"> {{iteration.year}} </td>
            </ng-container>

            <ng-container matColumnDef="startDate">
                <th mat-header-cell *matHeaderCellDef> Start Date </th>
                <td mat-cell *matCellDef="let iteration">
                    {{formatInUserTimezone(iteration.startDate, 'MM/DD/YYYY')}}
                </td>
            </ng-container>

            <ng-container matColumnDef="endDate">
                <th mat-header-cell *matHeaderCellDef> End Date </th>
                <td mat-cell *matCellDef="let iteration">
                    {{formatInUserTimezone(iteration.endDate, 'MM/DD/YYYY')}}
                </td>
            </ng-container>

            <ng-container matColumnDef="startTime">
                <th mat-header-cell *matHeaderCellDef> Start Time </th>
                <td mat-cell *matCellDef="let iteration">
                    {{formatInUserTimezone(iteration.startDate, 'h:mm A')}}
                </td>
            </ng-container>

            <ng-container matColumnDef="endTime">
                <th mat-header-cell *matHeaderCellDef> End Time </th>
                <td mat-cell *matCellDef="let iteration">
                    {{formatInUserTimezone(iteration.endDate, 'h:mm A')}}
                </td>
            </ng-container>

            <ng-container matColumnDef="entryFee">
                <th mat-header-cell *matHeaderCellDef> Entry Fee </th>
                <td mat-cell *matCellDef="let iteration">
                    {{iteration.entryFee | currency}}
                </td>
            </ng-container>

            <ng-container matColumnDef="totalMembers">
                <th mat-header-cell *matHeaderCellDef> Total Members </th>
                <td mat-cell *matCellDef="let iteration">
                    {{iteration.totalMembers || 0}}
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef> Actions </th>
                <td mat-cell *matCellDef="let iteration">
                    <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-menu #actionsMenu>
                        <button mat-menu-item (click)="onManageMembers(iteration)">
                            <mat-icon>people</mat-icon>
                            <span>Manage Members</span>
                        </button>
                        <mat-divider></mat-divider>
                        <button mat-menu-item (click)="onEdit(iteration)">
                            <mat-icon>edit</mat-icon>
                            <span>Edit</span>
                        </button>
                        <button mat-menu-item (click)="onClone(iteration)">
                            <mat-icon>content_copy</mat-icon>
                            <span>Clone</span>
                        </button>
                        <button mat-menu-item (click)="onDelete(iteration)">
                            <mat-icon>delete</mat-icon>
                            <span>Delete</span>
                        </button>
                    </mat-menu>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <div *ngIf="iterations.length === 0 && !isLoading" class="text-center py-5">
            <p class="text-muted">No iterations yet. Click "Add Iteration" to create the first one.</p>
        </div>
    </div>
</div>